import React, { useEffect, useState } from 'react'
import delet from '../../../../Assets/Images/delete.svg';
import edit from '../../../../Assets/Images/edit.svg';
import Popup from 'reactjs-popup';
import { Link, useParams } from 'react-router-dom';
import { useHome } from '../../../../Context/HomeContext';
import { ToastContainer, toast } from 'react-toastify';
import LoadingOverlay from '../../../LoadingOverlay/LoadingOverlay';
import DeletModal from '../../../DeleteModel/DeletModal';

function AllPartnersTable() {
  const { getPartner, isPartner, deletePartner } = useHome();
  const { lang } = useParams();

  useEffect(() => {
    getPartner(lang);
  }, []);

  const handleDeletePartner = async (id) => {
    try {
      await deletePartner(id, lang);
      toast.success("Partner deleted successfully!");
    } catch (error) {
      toast.error("Error deleting Partner!");
      console.error("Error deleting Partner:", error);
    }
  };

  return (
    <div className='bg-[#fff] rounded-2xl p-3'>
      {!isPartner && <LoadingOverlay />} {/* Display loading overlay */}
      <table className='w-full border-collapse mb-6'>
        <thead>
          <tr className='p-2'>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '10%' }}>SN</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '20%' }}>Image</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '20%' }}>Name</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '10%' }}>Order</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '20%' }}>Status</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '20%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {isPartner?.data?.map((Partner, index) => (
            <tr key={index}>
              <td className='p-5 text-start' style={{ width: '10%' }}>{String(index + 1).padStart(2, '0') + "."}</td>
              <td className='p-5 text-start' style={{ width: '20%' }}><img src={Partner.image_url} alt="" className='w-[125px] h-[125px] rounded-xl object-contain' /></td>
              <td className='p-5 text-start' style={{ width: '20%' }}>{Partner.name}</td>
              <td className='p-5 text-start' style={{ width: '10%' }}>{Partner.order}</td>
              <td className='p-5 text-start' style={{ width: '20%' }}>
                <div className={Partner.status == 1 ?
                  'bg-[#0966AE] text-[#fff] p-2 w-[75px] rounded-md border text-center' :
                  'bg-[#ffc107] p-2 w-[75px] rounded-md border text-center'}>
                  {Partner.status == 1 ? "Publish" : "Draft"}
                </div></td>
              <td className='p-5 text-center' style={{ width: '20%' }}>
                <div className='flex gap-2 items-center'>
                  <Link to={`/Home/EditPartner/${Partner.id}`}>
                    <div className='bg-[#148342] p-2 w-[40px] cursor-pointer rounded-md border'>
                      <img src={edit} alt="" />
                    </div>
                  </Link>
                  <Popup
                    trigger={
                      <div className='bg-[#AF1F24] p-2 w-[40px] cursor-pointer rounded-md border'>
                        <img src={delet} alt="" />
                      </div>
                    }
                    modal
                    nested
                  >
                    {(close) => (
                      <div className="modal">
                        <DeletModal close={close} id={Partner.id} onDelete={() => handleDeletePartner(Partner.id)} />
                      </div>
                    )}
                  </Popup>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
    </div>
  );
}

export default AllPartnersTable